export default {"src":"/_next/static/media/referrals.db43059f.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};